import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import SectionHeader from '../sectionHeader'
import { Mission, Vision } from '../../assets/svg'
import SectionSubHeader from '../sectionSubHeader'
import { Link } from 'react-router-dom'
import { BsArrowRight } from 'react-icons/bs'

const VisionMission = () => {
  return (
    <div className='volto-section our-vision-mission pb-80' id="vision-mission">
        <Container>
            <Row className='tab-row' style={{alignItems:"unset"}}>
                <Col lg={5}>
                 <div className='our-vision'>
                    <span className='d-flex gap-2'><Vision />  <SectionHeader mainText1={"Our "} mainText2={"Vision"} /></span>
                    <SectionSubHeader headerText={"Success with Purpose"} />
                    <p className='about-volto-text text-balance pr-70'>With a customer-centric approach, we blend strategic expertise to create outcomes that are not only measurable but also sustainable.</p>
                    <Link className="volto-know-more" to={"/contact"}>
                    Join Us{" "}<span><BsArrowRight /></span>
                    </Link>
                 </div>
                </Col>
                <Col lg={7}>
                  <div className='mission-card'>
                      <div className='mission-container'>
                      <span className='d-flex gap-2'><Mission />  <SectionHeader mainText1={"Our "} mainText2={"Mission"} /></span>
                      <SectionSubHeader headerText={"Shaping the Future"} />
                      <div className='mission-detail mt-4'>
                      <img src="/images/integration.svg" alt="hand-rise" />
                      <div>
                      <h4> Integrity as a Compass</h4>
                      <h6>Every decision is driven by transparency & accountability.</h6>
                      </div>
                        
                      </div>
                      <div className='mission-detail'>
                      <img src="/images/growth-about.svg" alt="growth" />
                      <div>
                      <h4> Innovation with Impact</h4>
                      <h6>Each solution is designed to achieve meaningful growth.</h6>
                      </div>
                        
                      </div>
                      <div className='mission-detail'>
                      <img src="/images/hand-rise.svg" alt="hand-rise" />
                      <div>
                      <h4> Empowered Together</h4>
                      <h6>A strong team structure boosts our pursuit of excellence.</h6>
                      </div>
                        
                      </div>
                      </div>
                     <img className='img-fluid bg-card' src="/images/mission-card.png" alt="mission-card" />
                  </div>
                </Col>
            </Row>
        </Container>
      
    </div>
  )
}

export default VisionMission
